import { ApplicationTypes, attachComponent } from 'metalworks-domain'

import {
  distanceDimensionComponent,
  htmlHotspotComponent,
  sceneEntityCustomObjectComponent,
  sceneEntityPropertiesComponent,
  selectableComponent,
} from '@salsita-ai/platform-project-sdk/domain'

import { createSelectedFeatureOutline } from '../canvas/selected-feature-outline'
import { FeatureSelectionHotspot } from '../ui/FeatureSelectionHotspot'

export const holeComponents = [
  // TODO: yaml
  attachComponent
    .withComponent(sceneEntityPropertiesComponent, 'main')
    .withAlias('Hole')
    .attach(s => ({
      offsetX: s.$absCoords3D.x,
      offsetY: s.$absCoords3D.y,
      offsetZ: s.$absCoords3D.z,
    })),
  // TODO: should no longer be needed
  attachComponent
    .withAlias('Hole')
    .withFilter(s => ({
      selectedEntityIds: [s.id],
    }))
    .withComponent(sceneEntityCustomObjectComponent, 'Outline')
    .attach(s => ({
      object: createSelectedFeatureOutline(s),
    })),
  attachComponent
    .withComponent(selectableComponent, 'default')
    .withAlias('Hole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    .attach(() => ({})),
  attachComponent
    .withComponent(htmlHotspotComponent, 'select')
    .withAlias('Hole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(self => ({
      offsetX: 0,
      offsetY: 0,
      offsetZ: self.$plate.thickness + 1,
      unit: 'mm',
      disableOcclude: true,
      node: <FeatureSelectionHotspot id={self.id} />,
    })),
  // TODO: yaml
  attachComponent
    .withComponent(distanceDimensionComponent, 'x')
    .withAlias('Hole')
    .attach(
      s => ({
        value: s.x,
        min: s.$minX,
        max: s.$maxX,
        unit: 'mm',
      }),
      v => {
        return {
          x: v.value,
        }
      }
    ),
  // TODO: yaml
  attachComponent
    .withComponent(distanceDimensionComponent, 'y')
    .withAlias('Hole')
    .attach(
      s => ({
        value: s.y,
        min: s.$minY,
        max: s.$maxY,
        unit: 'mm',
      }),
      v => {
        return {
          y: v.value,
        }
      }
    ),
]
